import { computed } from 'vue';
import { List } from '@superthread-com/api';
import { getCardStatus } from '@/utilities/defaultCardStatuses';
import cardStatusType from '@/types/cardStatusType';
import { useStore } from 'vuex';
import constants from '../constants';

interface ListExtended extends List {
  orginalId: string;
}

type StatusKey = (typeof cardStatusType)[keyof typeof cardStatusType];

export default function useBoardLists(listIds: any) {
  const store = useStore();
  const lists = computed(() => store.getters.lists);

  const getColorAndIcon = (
    color: string | undefined,
    icon: string | undefined,
    behavior: string | undefined,
    isEpic: boolean | undefined
  ) => {
    const defaultStatus = getCardStatus(
      Object.values(cardStatusType).includes(behavior as StatusKey)
        ? (behavior as StatusKey)
        : cardStatusType.Backlog,
      isEpic
    );

    return {
      color: color ?? defaultStatus.color,
      icon: defaultStatus?.icon ?? icon,
    };
  };

  const boardLists = computed(() => {
    const flatLists: any[] = [];

    listIds.value.forEach((l: any) => {
      const list: ListExtended = lists.value[l];
      const isEpic = list?.board_id === constants.epicsBoardId;

      if (list && list.orginalId !== constants.rolledOverList) {
        const behavior = list.behavior;
        const { color: listColor, icon: listIcon } = getColorAndIcon(
          list.color,
          list.icon,
          behavior,
          isEpic
        );
        flatLists.push({
          id: behavior,
          label: list.title,
          color: listColor,
          icon: listIcon,
          list_id: list.id,
        });
      }
    });
    return flatLists;
  });

  return {
    boardLists,
  };
}
